module.exports = require("./fr-GQ");